// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table-module--wrapper--3XHs7","blockquoteWrapper":"Table-module--blockquoteWrapper--12I7v","table":"Table-module--table--HhbTg"};